import React, { useState } from "react";
import { Carousel, CarouselControl, CarouselIndicators, CarouselItem } from "reactstrap";

import { Banner } from "../../api";
import SmartLink from "../../common/components/SmartLink";

interface BannerCarouselProps {
  items: Banner[];
}

const BannerCarousel: React.FC<BannerCarouselProps> = ({
  items,
}) => {

  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const showControls = 1 < items.length;

  const next = () => {
    if (!isAnimating) {
      const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
      setActiveIndex(nextIndex);
    }
  };

  const previous = () => {
    if (!isAnimating) {
      const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
      setActiveIndex(nextIndex);
    }
  };

  const goToIndex = (newIndex: number) => {
    if (!isAnimating) {
      setActiveIndex(newIndex);
    }
  };

  const slides = items.map((item) => (
    <CarouselItem
      onExiting={() => setIsAnimating(true)}
      onExited={() => setIsAnimating(false)}
      key={item.id}
    >
      <SmartLink className="d-block w-100" url={item.linkUrl}>
        <img className="d-block w-100" src={item.imageUrl} alt={item.imageAltText} />
      </SmartLink>
    </CarouselItem>
  ));

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      ride="carousel"
    >
      {showControls && (
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />)}
      {slides}
      {showControls && (
        <>
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={previous}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={next}
          />
        </>)}
    </Carousel>
  );
}

export default BannerCarousel;
